import React, { Component } from 'react';
import './HeaderBlock.css'
import Modal from 'react-modal'

import {StorageContext} from '../MenuMaker'

class HeaderBlock extends Component {
  state={
    showEditor: false
  }
  editContent = () => {
    this.setState({showEditor: true})
  }
  hideEditor = () => {
    this.setState({showEditor: false})
  }
  handleChange = (event) => {
    let {name, value} = event.target

  }
  render() {
    let {id, content={}} = this.props
    let {title, description} = content
    let articleClassName = this.state.showEditor ? "block-item header" : "block-item header draggable-handle"
    return(
      <article className={articleClassName} key={id}>
        <button
          className="no-print header-block__edit-button"
         
         onClick={this.editContent}>edit</button>

        <div className="header-block__content">
          <h2 className="header-block__title">{title}</h2>
          <p>{description}</p>
        </div>



        <Modal
          isOpen={this.state.showEditor}
          onClick={(e) => e.stopPropagation()}
          style={{
            overlay: {
              background: 'none',
              top: null,

            },
            content: {
              top: null,
              background: '#51a7d2'
            }
          }}
          >

              <StorageContext.Consumer>{
                ({blocksRef}) => {
                  const handleChange = (event) => {
                    // console.log(id)
                    blocksRef.child(id).child('content').update({[event.target.name]: event.target.value})
                  }
                  return(
                    <form>
                      Title: <input onChange={handleChange} type="text" name="title" value={title}/>
                      Description: <input onChange={handleChange} type="text" name="description" value={description}/>
                      <button onClick={this.hideEditor}>Done</button>
                    </form>
                  )
                }
              }</StorageContext.Consumer>


          </Modal>
      </article>
    )
  }
}
export default HeaderBlock
